import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Invoice from './component/Invoice'
import Root from './component/Root'
import './App.css'

function App () {
  return (
    <Routes>
      <Route path='/' element={<Root />} />
      <Route path='/invoice/:reservationId' element={<Invoice />} />
      <Route
        path='*'
        element={
          <main>
            <p>There's nothing here!</p>
          </main>
        }
      />
    </Routes>
  )
}

export default App
